import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { SubEntityType } from "../../../types/ScientificModule";
import { routes } from "../../../routes";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { createSubEntity } from "../../../services/scientific/subEntity";
import { CreateSubEntityFormValidation } from "./CreateSubEntityValidationForm";
import { useGetEntitiesQuery } from '../../../hooks/scientific/useGetEntitiesQuery';
import SelectComponent from "../../../components/inputs/Select/SelectComponent";

export const CreateSubEntity = () => {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createSubEntity, mutationKey: "createSubEntity" });
  const { data: entities, isLoading:isLoadingEntities, isError:isErrorEntities, refetch:refreshEntities } = useGetEntitiesQuery({ PageNumber: 1, PageSize: 400});
  

  const defaultValues: SubEntityType = {
    id: "",
    description: "",
    idEntity: "",
    status: true,
  };

  const { control, handleSubmit, formState: { errors } } = useForm<SubEntityType>({
    resolver: yupResolver(CreateSubEntityFormValidation),
    defaultValues,
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUseNativeValidation: false,
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("SubEntidade criada com sucesso!");
        navigate(routes.subEntities);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    navigate(routes.subEntities);
  };

  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size="1">
        <Flex direction="column" gap="4">
          <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: "Descrição" }} required={true}/>
          <SelectComponent
                name="idEntity"
                label="Entidade (Sigla)"
                control={control}
                errors={errors}
                options={entities?.items.map((entity) => ({
                  value: entity.id ?? "",
                  label: entity.description ?? "",
                }))}
                style={{width:'100%'}} 
                itemsLoading={isLoadingEntities}
                itemsError={isErrorEntities}
                required={true}
              />
          <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
            <Button color="red" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading} variant="surface">
              {mutation.isLoading ? <Spinner loading><EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
};
